{
  "kk": {
    "mainTabbar": {
      "search": "Іздеу",
      "cabinet": "Билеттер",
      "bank": "Банкке қайту",
      "passengers": "Жолаушылар"
    }
  },
  "ru": {
    "mainTabbar": {
      "search": "Поиск",
      "cabinet": "Билеты",
      "bank": "в Банк",
      "passengers": "Пассажиры"
    }
  },
  "en": {
    "mainTabbar": {
      "search": "Search",
      "cabinet": "Tickets",
      "bank": "Back to Bank",
      "passengers": "Passengers"
    }
  }
}
